export default "__VITE_PUBLIC_ASSET__c82b11aa__"